import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseServiceV2 } from '@servicesv2';
import { DespesasViewModel } from '../../financeiro/despesas/despesas-detalhe/model/DespesasViewModel';

@Injectable()
export class DespesasServiceV2 extends BaseServiceV2 {

  constructor(http: HttpClient) {
    super('Despesas', http);
  }

  salvarDespesasV2(payload: DespesasViewModel[]) {
    return this.postAsPromise<DespesasViewModel[], any>(payload, "salvarDespesasV2");
  }
}
